import createDecorator from "final-form-calculate";
import { checkJsonProp } from "../../../Utilities";

export const decorators = createDecorator(
  {
    field: /companyFunds.0.data\.*/,
    updates: {
      "companyFunds.0.companyFundsValid": (value, allValues) =>
        Object.keys(allValues.companyFunds[0].data)
          .map(keyItem => {
            return allValues.companyFunds[0].data[keyItem];
          })
          .some(item => item)
    }
  },
  {
    field: /clientPoliticsPosition.0.data\.*/,
    updates: {
      "clientPoliticsPosition.0.clientPoliticsValid": (value, allValues) =>
        Object.keys(allValues.clientPoliticsPosition[0].data)
          .map(keyItem => {
            return allValues.clientPoliticsPosition[0].data[keyItem];
          })
          .some(item => item)
    }
  },
  {
    field: "clientAddress.0.clientSameRealAddress",
    updates: (value, name, allValues) => {
      if (value)
        return {
          "clientAddress.1.data.addressCountry": checkJsonProp(
            allValues,
            "clientAddress.0.data.addressCountry"
          ),
          "clientAddress.1.data.addressCity": checkJsonProp(
            allValues,
            "clientAddress.0.data.addressCity"
          ),
          "clientAddress.1.data.addressStreet": checkJsonProp(
            allValues,
            "clientAddress.0.data.addressStreet"
          ),
          "clientAddress.1.data.addressHouse": checkJsonProp(
            allValues,
            "clientAddress.0.data.addressHouse"
          ),
          "clientAddress.1.data.addressFlat": checkJsonProp(
            allValues,
            "clientAddress.0.data.addressFlat"
          ),
          "clientAddress.1.data.addressPostCode": checkJsonProp(
            allValues,
            "clientAddress.0.data.addressPostCode"
          )
        };
      else
        return {
          "clientAddress.1.data.addressCountry": "",
          "clientAddress.1.data.addressCity": "",
          "clientAddress.1.data.addressStreet": "",
          "clientAddress.1.data.addressHouse": "",
          "clientAddress.1.data.addressFlat": "",
          "clientAddress.1.data.addressPostCode": ""
        };
    }
  },
  {
    field: /clientBeneficiaries\.*.*data\.*/,
    updates: {
      "clientBeneficiaries.0.uboretail": (value, allValues) => {
        const benefShareCnt = allValues.clientBeneficiaries.reduce(
          (count, item) => count + (item.data.clientBenefShare || 0),
          0
        );
        return {
          value: benefShareCnt,
          minValue: allValues.clientBeneficiaries[0].data.uboretail ? 0.01 : 75
        };
      }
    }
  },
  {
    field: "mainCustom.0.retail",
    updates: (value, name, allValues) => {
      if (value) {
        return {
          "mainCustom.0.retail": value,
          "mainCustom.0.customerEmpty": false,
          "mainCustom.0.checkedRetailOrEmpty": true
        };
      }
      return {
        "mainCustom.0.retail": value,
        "mainCustom.0.checkedRetailOrEmpty": allValues?.mainCustom?.[0]?.customerEmpty || false
      };
    }
  },
  {
    field: "mainCustom.0.customerEmpty",
    updates: (value, name, allValues) => {
      if (value) {
        return {
          "mainCustom.0.customerEmpty": value,
          "mainCustom.0.retail": false,
          "mainCustom.0.checkedRetailOrEmpty": true
        };
      }
      return {
        "mainCustom.0.customerEmpty": value,
        "mainCustom.0.checkedRetailOrEmpty": allValues?.mainCustom?.[0]?.retail || false
      };
    }
  },
  {
    field: "clientCeo.0.data.otherCeoCitizien",
    updates: (value, name, allValues) => {
      if (value)
        return {
          "clientCeo.0.data.otherCeoCitDocTy": checkJsonProp(
              allValues,
              "clientCeo.0.data.otherCeoCitDocTy"
          ),
          "clientCeo.0.data.otherCeoCitDocNo": checkJsonProp(
              allValues,
              "clientCeo.0.data.otherCeoCitDocNo"
          ),
          "clientCeo.0.data.otherCeoCitDocCountry": checkJsonProp(
              allValues,
              "clientCeo.0.data.otherCeoCitDocCountry"
          ),
          "clientCeo.0.data.otherCeoCitizienSch": checkJsonProp(
              allValues,
              "clientCeo.0.data.otherCeoCitizienSch"
          )
        };
      else
        return {
          "clientCeo.0.data.otherCeoCitDocTy": "",
          "clientCeo.0.data.otherCeoCitDocNo": "",
          "clientCeo.0.data.otherCeoCitDocCountry": "",
          "clientCeo.0.data.otherCeoCitizienSch": ""
        };
    }
  },
  {
    field: "clientBeneficiaries.0.data.otherClientBenefRegCountry",
    updates: (value, name, allValues) => {
      if (value)
        return {
          "clientBeneficiaries.0.data.otherClientBenefRegDocType": checkJsonProp(
              allValues,
              "clientBeneficiaries.0.data.otherClientBenefRegDocType"
          ),
          "clientBeneficiaries.0.data.otherClientBenefRegDocNo": checkJsonProp(
              allValues,
              "clientBeneficiaries.0.data.otherClientBenefRegDocNo"
          ),
          "clientBeneficiaries.0.data.otherClientBenefRegDocCountry": checkJsonProp(
              allValues,
              "clientBeneficiaries.0.data.otherClientBenefRegDocCountry"
          ),
          "clientBeneficiaries.0.data.otherClientBenefRegCountSch": checkJsonProp(
              allValues,
              "clientBeneficiaries.0.data.otherClientBenefRegCountSch"
          )
        };
      else
        return {
          "clientBeneficiaries.0.data.otherClientBenefRegDocType": "",
          "clientBeneficiaries.0.data.otherClientBenefRegDocNo": "",
          "clientBeneficiaries.0.data.otherClientBenefRegDocCountry": "",
          "clientBeneficiaries.0.data.otherClientBenefRegCountSch": ""
        };
    }
  },
  {
    field: "clientProfile.0.data.requireBusinessLicense",
    updates: (value, name, allValues) => {
      if (value)
        return {
          "clientProfile.0.data.businessLicenseNumber": checkJsonProp(
              allValues,
              "clientProfile.0.data.businessLicenseNumber"
          )
        };
      else
        return {
          "clientProfile.0.data.businessLicenseNumber": ""
        };
    }
  },
  {
    field: "clientProfile.0.data.amlRulesLeg",
    updates: (value, name, allValues) => {
      if (value)
        return {
          "clientProfile.0.data.amlProcedure": checkJsonProp(
              allValues,
              "clientProfile.0.data.amlProcedure"
          ),
          "clientProfile.0.data.amlCheckInSancLis": checkJsonProp(
              allValues,
              "clientProfile.0.data.amlCheckInSancLis"
          ),
          "clientProfile.0.data.amlOfficerEmail": checkJsonProp(
              allValues,
              "clientProfile.0.data.amlOfficerEmail"
          ),
          "clientProfile.0.data.amlOfficerNameSur": checkJsonProp(
              allValues,
              "clientProfile.0.data.amlOfficerNameSur"
          ),
          "clientPhone.0.data.amlOfficerPhone": checkJsonProp(
              allValues,
              "clientPhone.0.data.amlOfficerPhone"
          )
        };
      else
        return {
          "clientProfile.0.data.amlProcedure": "",
          "clientProfile.0.data.amlCheckInSancLis": "",
          "clientProfile.0.data.amlOfficerEmail": "",
          "clientProfile.0.data.amlOfficerNameSur": "",
          "clientPhone.0.data.amlOfficerPhone": ""
        };
    }
  }
);
